import { render, staticRenderFns } from "./Swim.vue?vue&type=template&id=32716e9b&"
import script from "./Swim.vue?vue&type=script&lang=js&"
export * from "./Swim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports